export const linkKirvanoCheckout3SPV = "https://pay.kirvano.com/8a9322fb-9613-450d-8859-b71f981fc58f";
export const linkCloudFunction = "https://lead-jqfvghdwpa-uc.a.run.app";
export const linkPlanner = "https://github.com/victommasi/links-jessica-vilela/blob/master/files/planner21dias.pdf?raw=true";
export const linkVSL = "https://github.com/victommasi/links-jessica-vilela/blob/master/videos/VSL1_low.mp4?raw=true";
